import { getAccessToken } from '@/lib/auth'
import { useQuery } from '@tanstack/react-query'
import { client } from './client'

// Types - matches server response_model exactly
export interface User {
  id: string
  email: string
  is_active: boolean
  is_verified: boolean
  created_at: string
  updated_at: string
}

interface GetMeResponse {
  user: User
}

// API functions
// GET /users/me returns { user: User } (envelope)
const getMe = (): Promise<GetMeResponse> => client.get('/users/me')

// React Query hooks
export function useMe() {
  const hasToken = !!getAccessToken()

  return useQuery({
    queryKey: ['users', 'me'],
    queryFn: async () => {
      const response = await getMe()
      return response.user // Unwrap envelope
    },
    retry: false,
    enabled: hasToken,
  })
}
